import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';


export function fetchLoyaltyRedemption(app, params) {
  const { id } = params;
  const docType = DocType.LOYALTY_REDEMPTION;
  return common.getDoc(app, { id, docType });
}

export function deleteLoyaltyRedemption(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.LOYALTY_REDEMPTION
  });
}

export function saveLoyaltyRedemption(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  const loyaltyRedemption = {
    doc_type: DocType.LOYALTY_REDEMPTION,
    name: util.toStringText(data.name),
    description: util.toStringText(data.description),
    available_from: (data.available_from) ? util.toStringDate(data.available_from) : null,
    available_to: (data.available_to) ? util.toStringDate(data.available_to) : null,
    conversion_rate: util.toNumber(data.conversion_rate),
    expiry: util.toInteger(data.expiry),
    redemption_type_id: data.redemption_type_id,
    currency_id: data.currency_id,
    price_level_id: data.price_level_id,
    payment_type_id: data.payment_type_id,
    cash_rounding_id: data.cash_rounding_id,
    excluded_locations: util.toObjectIds(
      data.excluded_locations,
      data.excluded_locations_ids,
      'location_id',
    ),
    excluded_subsidiaries: util.toObjectIds(
      data.excluded_subsidiaries,
      data.excluded_subsidiaries_ids,
      'subsidiary_id',
    ),
  };
  return common.saveDoc(app, {
    source: data,
    doc: loyaltyRedemption,
    user
  });
}
